// src/User/Home.js  — añadir sección "expedientes"
// Cambios: import ExpedientesUsuario + case en renderContent + Nav.Link

import React, { useState, useEffect } from "react";
import logo from "../Images/SECTORB12.png";
import { Container, Row, Col, Nav, Navbar, Card, Button, Accordion } from "react-bootstrap";
import documentosjpg from "../Images/documentos.jpg";
import registro from "../Images/registro.jpg";
import solicitudesjpg from "../Images/solicitudes.jpeg";
import notificacionesjpg from "../Images/notificaciones.jpeg";
import "bootstrap/dist/css/bootstrap.min.css";
import "../App.css";
import BuzonRegistro from "./BuzonRegistro";
import PublicacionesUsuario from "./PublicacionesUsuario";
import NotificacionesUsuario from "./NotificacionesUsuario";
import SolicitudesUsuario from "./SolicitudesUsuario";
import DocumentosPresentados from "./DocumentosPresentados.js";
import ExpedientesUsuario from "./ExpedientesUsuario";   // ← NUEVO
import Header from "../Components/Header.js";
import Footer from "../Components/Footer.js";

const Home = () => {
  const [activeSection, setActiveSection] = useState("home");
  const [notificacionesNoLeidas, setNotificacionesNoLeidas] = useState(0);
  const userId = localStorage.getItem("id");

  const fetchNotificaciones = async () => {
    try {
      const response = await fetch(
        `https://sectorb12.info/api/notificaciones/usuarios/${userId}`
      );
      if (response.ok) {
        const data = await response.json();
        setNotificacionesNoLeidas(data.filter((n) => !n.Recepcion).length);
      }
    } catch (error) {
      console.error("Error al obtener notificaciones:", error);
    }
  };

  useEffect(() => {
    if (userId) fetchNotificaciones();
  }, [userId]);

  const renderContent = () => {
    switch (activeSection) {
      case "home":
        return (
          <Row>
            <Header />
            {[
              { key: "registro",       src: registro,          title: "Registro",       desc: "Acceda al registro electrónico.",            btn: "Registro" },
              { key: "documentos",     src: documentosjpg,     title: "Documentos",     desc: "Compruebe sus documentos presentados.",      btn: "Documentos" },
              { key: "notificaciones", src: notificacionesjpg, title: "Notificaciones", desc: "Compruebe sus notificaciones recibidas.",    btn: "Notificaciones" },
              { key: "solicitudes",    src: solicitudesjpg,    title: "Solicitudes",    desc: "Compruebe sus solicitudes presentadas.",     btn: "Solicitudes" },
              { key: "expedientes",    src: documentosjpg,     title: "Expedientes",    desc: "Consulte sus expedientes y códigos CVE.",    btn: "Expedientes" },
            ].map(({ key, src, title, desc, btn }) => (
              <Col md={6} key={key}>
                <Card className="mb-4 shadow-sm">
                  <Card.Img variant="top" src={src} alt={title} />
                  <Card.Body>
                    <Card.Title><strong>{title}</strong></Card.Title>
                    <Card.Text>{desc}</Card.Text>
                    <Button variant="success" onClick={() => setActiveSection(key)}>
                      {btn}
                    </Button>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        );
      case "registro":      return <BuzonRegistro />;
      case "documentos":    return <DocumentosPresentados />;
      case "notificaciones":
        return <NotificacionesUsuario onActualizarLeidas={fetchNotificaciones} />;
      case "solicitudes":   return <SolicitudesUsuario />;
      case "expedientes":   return <ExpedientesUsuario />;   // ← NUEVO
      case "publicaciones": return <Row><PublicacionesUsuario /></Row>;
      default:              return <h3>Inicio</h3>;
    }
  };

  return (
    <Container fluid>
      <Row className="min-vh-100">
        <Col xs={12} md={3} lg={2} className="sidebar bg-light">
          <Navbar className="flex-column pt-3 d-none d-md-flex">
            <Navbar.Brand className="text-success mb-4">
              <img src={logo} alt="Logo" style={{ width: "140px", objectFit: "contain" }} />
            </Navbar.Brand>
            <Nav className="flex-column">
              {[
                { key: "home",           icon: "bi-house",             label: "Inicio" },
                { key: "registro",       icon: "bi-pencil-square",     label: "Buzón de Registro" },
                { key: "documentos",     icon: "bi-file-earmark-text", label: "Documentos" },
                { key: "solicitudes",    icon: "bi-file-text",         label: "Solicitudes" },
                { key: "expedientes",    icon: "bi-folder2-open",      label: "Expedientes" },  // ← NUEVO
                { key: "publicaciones",  icon: "bi-megaphone",         label: "Publicaciones" },
              ].map(({ key, icon, label }) => (
                <Nav.Link
                  key={key}
                  className={activeSection === key ? "active" : ""}
                  onClick={() => setActiveSection(key)}
                >
                  <i className={`bi ${icon}`}></i> {label}
                </Nav.Link>
              ))}

              {/* Notificaciones con badge */}
              <Nav.Link
                className={activeSection === "notificaciones"
                  ? "active d-flex justify-content-between align-items-center"
                  : "d-flex justify-content-between align-items-center"}
                onClick={() => setActiveSection("notificaciones")}
              >
                <div><i className="bi bi-bell"></i> Notificaciones</div>
                {notificacionesNoLeidas > 0 && (
                  <span className="badge bg-danger rounded-pill ms-2">
                    {notificacionesNoLeidas}
                  </span>
                )}
              </Nav.Link>

              <Nav.Link
                className="text-danger"
                onClick={() => {
                  localStorage.removeItem("token");
                  window.location.href = "/login";
                }}
              >
                <i className="bi bi-box-arrow-right"></i> Cerrar Sesión
              </Nav.Link>
            </Nav>
          </Navbar>
        </Col>

        <Col xs={12} md={9} lg={10}>
          {renderContent()}
        </Col>
        <Footer />
      </Row>
    </Container>
  );
};

export default Home;